<!-- IMG BELOW IS THE BACKGROUND IMAGE THAT IS DISPLAYED UNDER THE SLIDING-ZOOM-BOX -->
<img #sliderBgImg class="img-fluid" [src]="imgPath" (load)="OnImageLoad(sliderBgImg)">
    
<!-- DIV BELOW IS THE ZOOM-BOX-CONTAINER USED TO PREVENT SLIDING BOX OUTSIDE OF DESIRED AREA -->
<div #SlidingZoomContainer class="container p-0">
        
    <!-- DIV BELOW IS THE SLIDING-ZOOM-BOX-->
    <div #SlidingZoomBox 
        class="zoom-box" 
        (mousedown)="OnStart($event)" 
        (touchstart)="OnStart($event)" 
        [style.marginTop.px]="zoomBoxStyle.boxMarginTop"
        [style.height.px]="zoomBoxStyle.boxHeight"
        [style.width.px]="zoomBoxStyle.boxWidth"
        [style.left.px]="currentX">

        <!-- THIS NESTED DIV IS USED TO DISPLAY TOP CORNERS WITHIN THE SLIDING-ZOOM-BOX -->
        <div class="m-0 p-2 top row">
            <div class="top-left-corner"></div>
            <div class="top-right-corner"></div>
        </div>

        <!-- THIS NESTED DIV IS USED TO DISPLAY BOTTOM CORNERS WITHIN THE SLIDING-ZOOM-BOX -->
        <div class="m-0 p-2 bottom row">
            <div class="bottom-left-corner"></div>
            <div class="bottom-right-corner"></div>
        </div>
    
    </div>

</div>
